import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mqBreakpoints from 'rp-mq-breakpoints';

class SireStatsExpansion extends Component {

    constructor(props) {
        super(props);
        this.state = { colSpan: (mqBreakpoints.current().max < 720) ? 5 : 10 };
    }

    componentDidMount() {
        window.addEventListener('rpBreakpointsSwitch', (e) => {
            this.onBreakpointChange.call(this, e);
        });
    }

    componentWillUnmount() {
        window.removeEventListener('rpBreakpointsSwitch', this.onBreakpointChange);
    }

    onBreakpointChange(Mq) {
        let colSpan = 10;
        if (Mq.detail.breakpoint.max < 720) {
            colSpan = 5;
        }
        this.setState({
            colSpan
        });
    }

    render() {
        function renderRow(data, displayName) {
            return (
                <tr className="ui-table__row">
                    <td className="ui-table__cell">&nbsp;</td>
                    <td className="ui-table__cell">{displayName}</td>
                    <td className="ui-table__cell">{data.total_count}</td>
                    <td className="ui-table__cell">{data.offered_count}</td>
                    <td className="ui-table__cell">{data.sales_count} ({data.sold_percent}%)</td>
                    <td className="ui-table__cell">{data.price_total}</td>
                    <td className="ui-table__cell">{data.price_average}</td>
                    <td className="ui-table__cell">{data.price_max}</td>
                    <td className="ui-table__cell">{data.median}</td>
                    <td className="ui-table__cell">{data.price_min}</td>
                </tr>
            );
        }

        function renderTable(colts, fillies) {
            return (
                <table className="ui-table table__StatSiresExpansion">
                    <tbody className="table__StatSiresExpansion_tbody">
                        {colts && renderRow(colts, 'Colts')}
                        {fillies && renderRow(fillies, 'Fillies')}
                    </tbody>
                </table>
            );
        }

        return (
            <tr className="ui-table__row table__StatSiresExpansion_exRow">
                <td colSpan={this.state.colSpan}>
                    {renderTable(this.props.data.colts, this.props.data.fillies)}
                </td>
            </tr>
        );
    }
}

SireStatsExpansion.propTypes = {
    /**
     * Row data
     * Own property
     */
    data: PropTypes.array.isRequired,
};

export default SireStatsExpansion;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/SireStatsExpansion.js